exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "my-details-page .hideOnInactive{display:none!important}my-details-page form.active .hideOnInactive{display:block!important}user-details-form form.active label span{margin:.5em 0 0!important}user-details-form form label span.fieldValue{white-space:pre-wrap!important;min-height:17px;font-size:.9em;margin-top:.2em}user-details-form form label span.fieldValue+.padFieldValue{margin-top:.5em}h2.sectionTitle{margin-top:2.5em!important}div.form-field.hideOnInactive{margin-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/profile/my-profile/my-details/my-details.styl
// module id = 965
// module chunks = 0